export enum ActionEnum {
    mlbInternetStatus = 'mlbInternetStatus',
    mlbTvStatus = 'mlbTvStatus',
    mlbVoipStatus = 'mlbVoipStatus',
    mlbWifiStatus = 'mlbWifiStatus',
    mlbKo = 'mlbKo',
}
